import React from 'react'
import noProfileImage from '../assets/images/user.jpg'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
    return (
        <div className='setting-nav-body'>
            <div className="nav-left-content">
                <div className="nav-setting-profile-img">
                    <img src={noProfileImage} alt="img" />
                </div>
                <div className="nav-setting-profile-info">
                    <div className="info-name">{props.userData.fullName} <span>({props.userData.username})</span></div>
                    <p>Your personal account</p>
                </div>
            </div>
            <div className="nav-right-content">
                <Link to={"profile"}><button>Go to your personal profile</button></Link>
            </div>
        </div>
    )
}
